import { render, staticRenderFns } from "./DeliveryFormResearch.vue?vue&type=template&id=4fe9a44a&scoped=true&"
import script from "./DeliveryFormResearch.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormResearch.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormResearch.vue?vue&type=style&index=0&id=4fe9a44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9a44a",
  null
  
)

export default component.exports